import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  'receipt-store-address-card:default-name-label': {
    id: 'receipt-store-address-card:default-name-label',
    defaultMessage: 'Store Address',
    description: 'Receipt Store Address Card: default name label if value is not provided',
  },
});
